/**
 * This function was accidentally exposed for mobile/native usage.
 *
 * @deprecated
 *
 * @return {string} Empty string.
 */
export default () => '';
